// @ts-nocheck
import $ from 'jquery';
import paths from 'paths';
import bootbox from 'bootbox';
import us from 'mesitis/services/userService';
import signalRHelper from 'mesitis/utils/signalRHelper';
import 'idleTimer';
import authComponent from 'mesitis/account/authComponent';
import bsPopupRenderer from 'mesitis/components/bsPopupRenderer';

var _hubName = 'userSessionHub';

    function sessionObserver() {
        this._notificationInactivityDiff = 31000;
        this._notificationAbsoluteDiff = 121000;

        this._inactivityTimeout = undefined;
        this._absoluteTimeout = undefined;

        this._idleTick = 1000;
        this._inactivityTimer = undefined;
        this._absoluteTimer = undefined;
        this._inactivityDialog = undefined;
        this._absoluteBackTimer = undefined;
        this._inactivityBackTimer = undefined;
        this._lastTimeIdleLength = 0;
    }

    sessionObserver.prototype._restartAbsoluteTimer = function () {
        var self = this;

        if (self._absoluteTimer) {
            clearTimeout(self._absoluteTimer);
        }

        self._absoluteTimer = setTimeout(function () {
            if (self._absoluteTimer) {
                clearTimeout(self._absoluteTimer);
            }
            if (self._inactivityTimer) {
                clearTimeout(self._inactivityTimer);
            }
            if (self._absoluteBackTimer) {
                clearInterval(self._absoluteBackTimer);
            }

            if (self._inactivityDialog) {
                self._inactivityDialog.modal('hide');
            }

            bootbox.confirm({
                title: 'Absolute Session Timeout Warning',
                message:
                    "<span id='absoluteTxt'><p>Your session will expire automatically in <span id='absoluteTimeTxt'>" +
                    (self._notificationAbsoluteDiff - 1000) / 1000 +
                    '</span> seconds.<br>To access your account, please log in again.</p></span>',
                buttons: {
                    confirm: {
                        label: 'Login',
                        className: 'btn-primary',
                    },
                    cancel: {
                        label: 'End Session Now',
                    },
                },
                callback: function (result) {
                    if (self._absoluteBackTimer) {
                        clearInterval(self._absoluteBackTimer);
                    }

                    if (result) {
                        self._login();
                    } else {
                        self._logoff();
                    }
                },
                onEscape: null,
                closeButton: false,
            });

            var elapsedTime = (self._notificationAbsoluteDiff - 1000) / 1000;
            self._absoluteBackTimer = setInterval(function () {
                elapsedTime -= 1;
                $('#absoluteTimeTxt').text(elapsedTime);
                if (elapsedTime <= 0) {
                        if (self._absoluteBackTimer) {
                            clearInterval(self._absoluteBackTimer);
                        }
                    $('#absoluteTxt').html(
                        '<p>Your session to Canopy Engine has timed out for security reasons. To access your account, please log in again.</p>'
                    );
                }
            }, 1000);
        }, self._absoluteTimeout - self._notificationAbsoluteDiff);
    };

    sessionObserver.prototype._restartInactivityTimer = function () {
        var self = this;

        if (self._inactivityTimer) {
            clearTimeout(self._inactivityTimer);
        }

        $(document).idleTimer({
            timeout: self._idleTick,
            timerSyncId: 'Mf0xsK2aykI5CkjOyT11',
        });
        $(document).idleTimer('reset');

        self._inactivityTimer = setTimeout(function () {
            var isIdle = $(document).idleTimer('isIdle');
            // console.log('Was idle: ', isIdle);

            if (!isIdle) {
                self._sendPing(false);
            } else {
                var idleTime = $(document).idleTimer('getElapsedTime');

                // console.log('idle time: ', idleTime, 'previous idle time', self._lastTimeIdleLength);

                // parts of formula:
                // _inactivityTimeout -             how much time for inactivity is allowed
                // _notificationInactivityDiff -    how much time we give to user to take action (showing notification) before session expires
                // (self._idleTick + 100) -         internally offset used by idleTimer component
                // _lastTimeIdleLength -            for how long user was inactive in previous time range

                // t:   A - - - - - - B - - - - - C
                //      ^             ^           ^
                //   Logged in    user active   timer
                //
                // Above: A - when user logged in
                //        B - user was active last time
                //        C - timer is fired
                // B-C - real inactivity time, need to sum this inactivity time when timer fires next time - _lastTimeIdleLength

                if (
                    idleTime + self._lastTimeIdleLength >=
                    self._inactivityTimeout - self._notificationInactivityDiff - (self._idleTick + 100)
                ) {
                    if (self._inactivityTimer) {
                        clearTimeout(self._inactivityTimer);
                    }

                    self._inactivityDialog = bootbox.confirm({
                        title: 'Session Timeout Warning',
                        message:
                            "<span id='inactivityTxt'><p>Your session will expire automatically in <span id='inactivityTimeTxt'>" +
                            (self._notificationInactivityDiff - 1000) / 1000 +
                            "</span> seconds.<br>Select 'Continue Session' to extend your session.</p></span>",
                        buttons: {
                            confirm: {
                                label: 'Continue Session',
                                className: 'continue-login-button btn-primary',
                            },
                            cancel: {
                                label: 'End Session Now',
                            },
                        },
                        callback: function (result) {
                            if (self._inactivityBackTimer) {
                                clearInterval(self._inactivityBackTimer);
                            }

                            if (result) {
                                // user just actioned, so calling sendPing with false
                                self._sendPing(false);
                            } else {
                                self._logoff();
                            }
                        },
                        onEscape: null,
                        closeButton: false,
                    });

                    var elapsedTime = (self._notificationInactivityDiff - 1000) / 1000;
                    self._inactivityBackTimer = setInterval(function () {
                        elapsedTime -= 1;
                        $('#inactivityTimeTxt').text(elapsedTime);
                        if (elapsedTime <= 0) {
                            if (self._inactivityBackTimer) {
                                clearInterval(self._inactivityBackTimer);
                            }
                            $('.continue-login-button').text('Login');
                            $('#inactivityTxt').html(
                                '<p>Your session to Canopy Engine has timed out for security reasons. To access your account, please log in again.</p>'
                            );
                        }
                    }, 1000);
                } else {
                    self._lastTimeIdleLength = idleTime;
                    self._sendPing(true);
                }
            }
        }, self._inactivityTimeout - self._notificationInactivityDiff - self._lastTimeIdleLength);

        // console.log('Setting inactive timeout:', self._inactivityTimeout - self._notificationInactivityDiff - self._lastTimeIdleLength);
    };

    sessionObserver.prototype._logoff = function () {
        this.srConnection.execute('releaseConnectionId');
        $.get(paths.appPath + 'Account/LogOff').always(function () {
            window.location.href = paths.appPath + 'Account/Login';
        });
    };

    sessionObserver.prototype._login = function () {
        var self = this;
        this.srConnection.execute('holdConnectionId');


        var popupHandler = bsPopupRenderer.renderComponent(
            authComponent,
            {
                restartTimers: function () {
                    self.restartTimers();
                    // self.srConnection('releaseConnectionId');
                    self.srConnection.execute('releaseConnectionId');
                }.bind(self),
                closePopup: function () {
                    popupHandler.close();
                },
                close: () => {
                    self._logoff();
                },
                loginMode: 2,
            },
            {
                keybord: false,
                css: 'login-component-width',
            }
        );

    };

    sessionObserver.prototype._sendPing = function (wasIdle) {
        var self = this;
        if (!wasIdle) {
            this._lastTimeIdleLength = 0;
        }

        us.ping(undefined, undefined, function (result, message, response) {
            if (response.getResponseHeader) {
                var respJson = paths.isDotnetCore ? result.timedout : response.getResponseHeader('X-Responded-JSON');
                if (respJson) {
                    if (self._absoluteTimer) {
                        clearInterval(self._absoluteTimer);
                    }
                    self._login();
                } else {
                    self._start(result);
                }
            } else self._login();
        });
    };

    sessionObserver.prototype._start = function (result) {
        var self = this;

        self._absoluteTimeout = result.abs;
        self._inactivityTimeout = result.inact;

        self._restartAbsoluteTimer();
        self._restartInactivityTimer();
    };

    sessionObserver.prototype.restartTimers = function () {
        var self = this;
        us.ping(undefined, undefined, function (result) {
            self._start(result);
        });
    };

    sessionObserver.prototype.connect = function () {
        var self = this;
        var isOpened = false;
        var sr = signalRHelper;

        if (paths.sessionSignalRUrl && sr.core) sr = sr.core(paths.sessionSignalRUrl);

        this.srConnection = sr.subscribe(_hubName, {
            sessionExpired: function () {
                if (isOpened) return;
                isOpened = true;

                if (self._absoluteTimer) {
                    clearTimeout(self._absoluteTimer);
                }
                if (self._inactivityTimer) {
                    clearTimeout(self._inactivityTimer);
                }
                if (self._inactivityDialog) {
                    self._inactivityDialog.modal('hide');
                }

                bootbox.confirm({
                    title: 'Concurrent Session Detected',
                    message:
                        "<span id='absoluteTxt'><p>This session to Canopy Engine has expired for security reasons. To access your account, please log in again.</p></span>",
                    buttons: {
                        confirm: {
                            label: 'Login',
                            className: 'btn-primary',
                        },
                        cancel: {
                            label: 'End Session Now',
                        },
                    },
                    callback: function (result) {
                        if (result) {
                            self._login();
                        } else {
                            self._logoff();
                        }
                        isOpened = false;
                    },
                    onEscape: null,
                    closeButton: false,
                });
            },
        });
    };
export default sessionObserver;
